
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 0a3 3 0 013 3v6a3 3 0 11-6 0V3a3 3 0 013-3zm7 9c0 3.53-2.61 6.44-6 6.93V19H6v-3.07c-3.39-.49-6-3.4-6-6.93h2a5 5 0 1010 0h2z","fill":"#006F39"}})])
          )
        }
      }
    